export default __webpack_public_path__ + "static/media/error.51ed94bd.svg";